import DOMPurify from 'dompurify';

/**
 * 공지사항 본문용 HTML sanitize.
 * - 허용 태그/속성을 명시적으로 제한
 * - 외부 링크는 rel/target 강제 (XSS·트래킹 안전성 확보)
 */
const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'u',
  's',
  'a',
  'ul',
  'ol',
  'li',
  'blockquote',
  'h2',
  'h3',
  'hr',
  'code',
  'span',
  'img',
];

const ALLOWED_ATTR = ['href', 'rel', 'target', 'class', 'src', 'alt', 'title'];

/**
 * 허용 URI 스킴:
 * - https / http / mailto / tel
 * - data:image/(png|jpeg|gif|webp|svg+xml);base64,...  (에디터 파일 업로드용)
 *
 * data:image 만 허용해 data:text/html 같은 XSS 벡터를 차단합니다.
 */
const ALLOWED_URI_REGEXP =
  /^(?:(?:https?|mailto|tel):|data:image\/(?:png|jpe?g|gif|webp|svg\+xml);base64,|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;

export function sanitizeAnnouncementHtml(html: string): string {
  if (!html) return '';
  const cleaned = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP,
  });

  if (cleaned.trim() === '<p></p>') return '';
  return cleaned;
}

/**
 * 약관 본문용 sanitize.
 * 공지사항 허용 태그 + 표. 개인정보처리방침은 수집항목·보유기간이 전부 표라서
 * 표를 떨어뜨리면 문서가 성립하지 않는다.
 */
const TERMS_ALLOWED_TAGS = [
  ...ALLOWED_TAGS,
  'h4',
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'th',
  'td',
  'caption',
  'colgroup',
  'col',
];

const TERMS_ALLOWED_ATTR = [...ALLOWED_ATTR, 'colspan', 'rowspan', 'scope'];

export function sanitizeTermsHtml(html: string): string {
  if (!html) return '';
  const cleaned = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: TERMS_ALLOWED_TAGS,
    ALLOWED_ATTR: TERMS_ALLOWED_ATTR,
    ALLOWED_URI_REGEXP,
  });

  if (cleaned.trim() === '<p></p>') return '';
  return cleaned;
}
